import { ISearchListColumn } from 'component/Search/IColumnExtensionType';
import { get, map } from 'lodash';
import moment from 'moment';

export const recursiveHandleColumns = <T>(
  data: ISearchListColumn['data'],
  item: T,
  fieldName?: string
) => {
  if (data?.filterItemOnSpreadsheet) {
    const result = data?.filterItemOnSpreadsheet(item);

    if (!result) {
      return '';
    }
  }

  const val = item && fieldName && get(item, fieldName);
  if (!data) {
    return val;
  }

  switch (data.renderType) {
    case 'list':
      if (val.length < 1) {
        return '';
      }
      return map(val, el => {
        if (data.onRenderListItem) {
          return data.onRenderListItem(el);
        }
        switch (typeof el) {
          case 'string':
          case 'bigint':
          case 'number':
          case 'undefined':
          case 'boolean':
            // Simple data structures should simply return
            return el;
          case 'function':
            return el();
          // I'm not sure under what circumstances we would ever use this
          // but supporting it to be thorough.
          case 'symbol':
            return el.toString();
          default:
            // We have a sub-list item and we should iterate into it
            return recursiveHandleColumns(
              data.listItemColumnData,
              el,
              data.listFieldName || fieldName
            );
        }
      });
    case 'date':
      if (!val) {
        return;
      }
      const outputDate = moment(new Date(val));
      if (outputDate.isValid()) {
        return outputDate.format('ll');
      }
      return val;
    case 'link':
      const link = (() => {
        //if we have a link maker function
        if (data.getLink) {
          return data.getLink(item);
        }
        //if we have a fieldName to pull links from
        const linkFieldName = data.linkFieldName;
        if (linkFieldName) {
          // using lodash `get` here allows for support of drilling in if item has objects as properties
          return get(item, data.linkFieldName);
        }
      })();
      //There's no link, so just return text.
      if (!link || link.length === 0) {
        return val;
      }
      const result = {
        type: require('exceljs').ValueType.Hyperlink,
        hyperlink: link,
        text: val,
        tooltip: `Open "${link}"`,
      };
      return result;
    case 'custom':
      /** If we have a custom cell rendering function, call it and return. */
      if (data.onRenderSpreadsheetCell) {
        return data.onRenderSpreadsheetCell(item);
      }
      return val;
    default:
      return val;
  }
};
